import { Controller } from '@hotwired/stimulus';

import AccountSnapshotFormValidator from '../models/account-snapshot-form-validator';

export default class extends Controller {
  static targets = ['requiredField', 'submitButton', 'startDate', 'endDate'];

  declare readonly requiredFieldTargets: HTMLInputElement[];

  declare readonly submitButtonTarget: HTMLInputElement;

  declare readonly startDateTarget: HTMLInputElement;

  declare readonly endDateTarget: HTMLInputElement;

  validate() {
    if (this.noEmptyFields() && this.validator.validate()) {
      this.submitButtonTarget.disabled = false;
    } else {
      this.submitButtonTarget.disabled = true;
    }
  }

  private noEmptyFields() {
    const emptyField = this.requiredFieldTargets.find(field => {
      return field.value === '';
    });

    return emptyField === undefined;
  }

  get validator() {
    return new AccountSnapshotFormValidator(this.startDateTarget.value, this.endDateTarget.value);
  }
}
